import { Phenology, PhenologyOut } from '../models/Phenology';
import { PagedResults } from '@abaco/web-common/src/Paging';
import { HTTPClient } from '@abaco/web-common/src/HTTP';

export default class PhenologyApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    async getPhenology(plot_id: number, veg_cycle: number, block_id?: number): Promise<PagedResults<Phenology>> {
        let res;
        if (block_id) {
            res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/blocks/${block_id}/vegetative_cycles/${veg_cycle}/bbch`, {
                params: {
                    offset: 0,
                    count: 300
                }
            });
        } else {
            res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/vegetative_cycles/${veg_cycle}/bbch`, {
                params: {
                    offset: 0,
                    count: 300
                }
            });
        }
        //propsToDatePaged(res.data, ['start_date', 'end_date'])
        return res.data;
    }

    async editPhenology(plot_id: number, veg_cycle: number, bbchCode: string, form: PhenologyOut, block_id?: number): Promise<Phenology>{
        let res;
        if (block_id) {
            res = await this.http.put(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/blocks/${block_id}/vegetative_cycles/${veg_cycle}/bbch/${bbchCode}`, form);
        } else {
            res = await this.http.put(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/vegetative_cycles/${veg_cycle}/bbch/${bbchCode}`, form);
        }
        return res.data;
    }
    async deletePhenology(plot_id: number, veg_cycle: number, bbchCode: string, block_id?: number): Promise<Phenology> {
        let res;
        if (block_id) {
            res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/blocks/${block_id}/vegetative_cycles/${veg_cycle}/bbch/${bbchCode}`);
        } else {
            res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/vegetative_cycles/${veg_cycle}/bbch/${bbchCode}`);
        }
        return res.data;
    }

}
